/**
 * Kalkulator karmy — dzienne zapotrzebowanie kcal.
 *
 * Obsługuje oba konteksty: standalone /kalkulator-karmy/ i widget na PDP
 * (oba używają [data-hn-kcal-form] / [data-hn-kcal-result]; widget jest
 * owinięty w [data-hn-kcal-widget] z data-product-id).
 *
 * Endpoint: POST /wp-json/hn/v1/kcal (inc/kcal-calculator.php).
 * Config: window.hnKcal { restUrl, nonce, labels }.
 */

const CFG = window.hnKcal || {};

function escHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
}

function showError(el, message) {
    if (!el) return;
    el.hidden = false;
    el.innerHTML = '<div class="hn-kcal-error">' + escHtml(message) + '</div>';
}

function renderResult(el, data) {
    if (!el) return;
    const f = data.feeding;
    let html = '';

    if (f && f.grams_per_day) {
        // Na PDP hero = PORCJA W GRAMACH (po to klient liczy); kcal jako kontekst niżej.
        html =
            '<div class="hn-kcal-result__big"><strong>~' + Math.round(f.grams_per_day) + ' g</strong> ' +
            '<span>tej karmy dziennie</span></div>' +
            '<p class="hn-kcal-result__factor">' + Math.round(data.mer) + ' kcal / dzień · ' +
            escHtml(data.factor_label) + '</p>';
        html += '<div class="hn-kcal-result__feeding"><ul>';
        let monthUnit = null;
        if (f.packs_per_month) {
            // puszka <1 kg, worek/opakowanie >=1 kg; polska odmiana 1/2-4/5+
            const n = f.packs_per_month;
            const small = f.pack_grams && f.pack_grams < 1000;
            monthUnit = small
                ? (n === 1 ? 'puszkę' : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? 'puszki' : 'puszek'))
                : (n === 1 ? 'opakowanie' : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? 'opakowania' : 'opakowań'));
            const listUnit = (small && n === 1) ? 'puszka' : monthUnit;
            html += '<li>Na miesiąc potrzebujesz <strong>~' + n + ' ' + listUnit + '</strong></li>';
        }
        if (f.days_per_pack) {
            const d = Math.round(f.days_per_pack);
            html += '<li>Opakowanie wystarczy na <strong>' + (d === 1 ? '1 dzień' : '~' + d + ' dni') + '</strong></li>';
        }
        if (f.cost_per_day) {
            html += '<li>Koszt karmienia: <strong>~' +
                Number(f.cost_per_day).toFixed(2).replace('.', ',') + ' zł / dzień</strong></li>';
        }
        html += '</ul></div>';
    } else {
        // Standalone /kalkulator-karmy/ (bez produktu) — gramów nie ma z czego policzyć.
        html =
            '<div class="hn-kcal-result__big"><strong>' + Math.round(data.mer) + '</strong> ' +
            '<span>kcal / dzień</span></div>' +
            '<p class="hn-kcal-result__factor">' + escHtml(data.factor_label) +
            ' · współczynnik ×' + data.factor + '</p>';
    }

    html +=
        '<details class="hn-kcal-result__detail"><summary>Jak to policzyliśmy?</summary>' +
        '<p>RER = 70 × waga<sup>0,75</sup> = ' + Math.round(data.rer) + ' kcal</p>' +
        '<p>MER = RER × ' + data.factor + ' = ' + Math.round(data.mer) + ' kcal/dzień</p></details>' +
        '<p class="hn-kcal-result__note">Wynik orientacyjny. Przy chorobach metabolicznych ' +
        'skonsultuj dawkowanie z weterynarzem.</p>';

    // CTA: dodaj miesięczny zapas do koszyka (tylko na PDP z policzonym feeding).
    if (f && f.packs_per_month) {
        const n = f.packs_per_month;
        const small = f.pack_grams && f.pack_grams < 1000;
        const accUnit = small
            ? (n === 1 ? 'puszkę' : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? 'puszki' : 'puszek'))
            : (n === 1 ? 'opakowanie' : (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? 'opakowania' : 'opakowań'));
        html += '<button type="button" class="hn-btn hn-btn--primary hn-btn--block hn-kcal-result__add" ' +
            'data-hn-kcal-add data-qty="' + n + '">🛒 Dodaj ' + n + ' ' + accUnit + ' do koszyka</button>';
    }

    el.hidden = false;
    el.innerHTML = html;
}

/** Dodaje miesięczny zapas do koszyka — ta sama ścieżka co PDP ATC
 *  (wc-ajax add_to_cart + trigger added_to_cart → side-cart sam się otwiera). */
async function addMonthlyToCart(btn, widget) {
    const productId = widget ? widget.getAttribute('data-product-id') : null;
    const qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    if (!productId) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Dodaję…';

    const fd = new FormData();
    fd.append('product_id', productId);
    fd.append('quantity', String(qty));

    try {
        const res = await fetch(window.location.origin + '/?wc-ajax=add_to_cart', {
            method: 'POST',
            credentials: 'same-origin',
            body: fd,
        });
        const data = await res.json().catch(() => ({}));
        if (data && data.error) {
            if (data.product_url) { window.location.href = data.product_url; return; }
            throw new Error('wc error');
        }
        if (window.jQuery) {
            window.jQuery(document.body).trigger('added_to_cart', [data.fragments || null, data.cart_hash || '', window.jQuery(btn)]);
            window.jQuery(document.body).trigger('wc_fragment_refresh');
        }
        document.dispatchEvent(new CustomEvent('hn:cart:updated', { detail: data }));
        btn.textContent = '✓ Dodano do koszyka';
        setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2500);
    } catch (e) {
        btn.textContent = 'Nie udało się — spróbuj ponownie';
        setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2500);
    }
}

export function initKcal() {
    const forms = document.querySelectorAll('[data-hn-kcal-form]');
    if (!forms.length) {
        return;
    }
    const endpoint = CFG.restUrl || '/wp-json/hn/v1/kcal';

    forms.forEach((form) => {
        const widget = form.closest('[data-hn-kcal-widget]');
        const scope = widget || form.parentElement;
        const result = scope ? scope.querySelector('[data-hn-kcal-result]') : null;

        // Delegacja klików CTA "Dodaj X do koszyka" (kontener przeżywa re-rendery innerHTML).
        if (result) {
            result.addEventListener('click', (e) => {
                const btn = e.target.closest('[data-hn-kcal-add]');
                if (btn) addMonthlyToCart(btn, widget);
            });
        }

        form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const fd = new FormData(form);
            const weight = parseFloat(fd.get('weight_kg'));
            if (!weight || weight <= 0) {
                showError(result, 'Podaj wagę zwierzaka.');
                return;
            }

            const payload = {
                species: fd.get('species') || 'dog',
                weight_kg: weight,
                activity: fd.get('activity') || 'normal',
                body_condition: fd.get('body_condition') || 'ideal',
                neutered: fd.get('neutered') ? 1 : 0,
            };
            const ageYears = parseFloat(fd.get('age_years'));
            if (!Number.isNaN(ageYears)) {
                payload.age_months = Math.round(ageYears * 12);
            }
            if (widget && widget.dataset.productId) {
                payload.product_id = parseInt(widget.dataset.productId, 10);
            }

            const button = form.querySelector('[type="submit"]');
            if (result) {
                result.hidden = false;
                result.innerHTML = '<p>' + escHtml(CFG.labels && CFG.labels.computing || 'Liczę…') + '</p>';
            }
            if (button) button.disabled = true;

            try {
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': CFG.nonce || '' },
                    body: JSON.stringify(payload),
                });
                const data = await response.json();
                if (!response.ok || !data || !data.mer) {
                    showError(result, (data && data.message) || (CFG.labels && CFG.labels.error) || 'Błąd obliczeń');
                } else {
                    renderResult(result, data);
                }
            } catch (error) {
                showError(result, (CFG.labels && CFG.labels.error) || 'Błąd połączenia');
            } finally {
                if (button) button.disabled = false;
            }
        });
    });
}
